import createReducer from '../lib/createReducer';
import * as types from '../actions/types';
import helpers from '../components/Conversations/helpers';
import utils from '../lib/utils';

export const conversations = createReducer(
  {
    notesBySessionId: {},
    getClientsDetails: false,
    clientsDetails: [], // Clients of selected conversation
    clientsAppointments: [], // Appointments of selected clients
    conversations: [],
    conversationSummary: {
      followup_count: 0,
    },
    conversationMeta: {
      conversation_count: 0,
      followup_count: 0,
      handled_count: 0,
    },
    sidenav_count: 0,
    searchResults: [],
    sessioncounter: 0,
    blockedNumbers: [],
    getOptoutnumbers: false,
    optoutnumbers: [],
    minimizesidebar: false,
    selectedLocation: {},
    postClinetNotes: false,
    autoResponseChange: false,
    allAssignmentMap: [],
    markResolved: null,
    markedAsResolved: false,
    errorMessage: null,
    isPostNoteSuccess: false,
    socketUpdate: new Date(),
    assignmentData: null,
    nextStartTime: null,
    loadingMore: false,
    contactSearch: [],
    advancedSearch: [],
    isAdvancedSearch: false,
    ongoingSearch: false,
    creatingNewConversation: false,
    getConversationMetrics: false,
    fetchConversationMetricsSuccess: false,
    conversationMetrics: {},
    incomingMessage: null,
    callerNameChange: false,
    callerNameChangeSuccess: false,
    callerNameChangeFailure: false,
    searchingConversation: false,
    latestConversationRequestId: null,
    getconversationDetailsFail: null,
    postunblockNumber: false,
    unblockSuccess: false,
    custom_tags: [],
    addingTagToUser: false,
    counts: {
      mine_user_ids: [],
      unassigned_user_ids: [],
      total_user_ids: [],
      all_assigned_user_ids: [],
      mycount: 0,
      allcount: 0,
      needsattentioncount: 0,
    },
  },
  {
    [types.GET_CONVERSATION_START](state, action) {
      const newState = Object.assign({}, state, {
        ...(!action.loadmore && { getconversations: true }),
        loadmore: action.loadmore,
        ...(action.loadmore && { loadingMore: true }),
      });

      return newState;
    },
    [types.GET_CONVERSATION_SUCCESS](state, action) {
      let combinedconversations = [];
      if (action.loadmore || utils.isEmptyObject(state.selectedLocation)) {
        combinedconversations = state.conversations.concat(
          action.conversations,
        );
      } else if (
        !utils.isEmptyObject(state.selectedLocation) &&
        state.conversations.length > 0
      ) {
        const slectedLocationConversations = state.conversations.filter(
          (data) => data.accounts.includes(state.selectedLocation.studioId),
        );
        combinedconversations = slectedLocationConversations.concat(
          action.conversations,
        );
      } else {
        combinedconversations = action.conversations;
      }
      const keys = ['id'];
      combinedconversations = combinedconversations.filter(
        ((s) => (o) => ((k) => !s.has(k) && s.add(k))(keys.map((k) => o[k]).join('|')))(new Set()),
      );
      let searchresults = [];
      if (action.search && action.search.length > 0) {
        searchresults = action.conversations;
      }
      const nextStartTime =
        action?.conversations?.length > 0
          ? action.conversations[0].startTime
          : null;
      const newState = Object.assign({}, state, {
        getconversations: false,
        loadmore: false,
        conversations: combinedconversations,
        nextStartTime,
        no_of_days: action.no_of_days,
        search: action.search,
        lastupdate: new Date(),
        loadingMore: false,
        counts: action.counts ? {
          ...action.counts,
          mycount: action.counts.mine_user_ids?.length || 0,
          allcount: action.counts.total_user_ids?.length || 0,
          needsattentioncount: action.counts.unassigned_user_ids?.length || 0,
        } : state.counts,
      });

      return newState;
    },
    [types.CLEAR_SEARCH](state) {
      const newState = Object.assign({}, state, {
        search: false,
        searchResults: [],
        loadmore: false,
      });

      return newState;
    },
    [types.GET_DEFAULT_CARD_FAIL](state) {
      const newState = Object.assign({}, state, {
        getconversations: false,
        lastupdate: new Date(),
      });

      return newState;
    },
    [types.SET_STATUS_START](state) {
      return {
        ...state,
        markedAsResolved: true,
      };
    },
    [types.SET_STATUS_SUCCESS](state, action) {
      const newConversations = state.conversations.slice();
      let markResolved = null;
      for (let i = 0, l = newConversations.length; i < l; i += 1) {
        if (newConversations[i].id === action.sessionId) {
          newConversations[i].action = action.data.status;
          markResolved = newConversations[i].id;
          newConversations[i].action_updated_by = action.data.updated_by;
          newConversations[i].action_updated_time = action.data.updated_time;
          break;
        }
      }

      return {
        ...state,
        conversations: newConversations,
        markResolved,
        statusupdate: new Date(),
      };
    },
    [types.SET_CALLER_NAME_SUCCESS](state, action) {
      const clients = state.clientsDetails.slice();
      const { client_id, user } = action.data;
      let index = clients.findIndex((client) => client.id === client_id);
      clients[index].firstName = user?.first_name;
      clients[index].lastName = user?.last_name;
      clients[index].name = user?.first_name + ' ' + user?.last_name;
      const newState = Object.assign({}, state, {
        callerNameChange: false,
        clientsDetails: clients,
      });
      return newState;
    },
    [types.SET_CALLER_NAME_START](state) {
      const newState = Object.assign({}, state, {
        callerNameChange: true,
      });
      return newState;
    },
    [types.SET_CALLER_NAME_FAIL](state, action) {
      const newState = Object.assign({}, state, {
        callerNameChange: false,
      });
      return newState;
    },
    [types.MARK_RESOLVE_CLEAR](state) {
      return {
        ...state,
        markedAsResolved: false,
      };
    },
    [types.GET_CLIENT_NOTES_SUCCESS](state, action) {
      const notesBySessionId = {
        ...state.notesBySessionId,
        [action.session_id]: action.conversation_notes,
      };

      return { ...state, notesBySessionId };
    },
    [types.GET_CONVERSATION_SUMMARY_START](state) {
      const newState = Object.assign({}, state, {
        getconversationsummary: true,
      });
      return newState;
    },
    [types.GET_CONVERSATION_SUMMARY_SUCCESS](state, action) {
      const newState = Object.assign({}, state, {
        getconversationsummary: false,
        conversationMeta: action.conversationSummary,
      });
      return newState;
    },
    [types.GET_CONVERSATION_SUMMARY_FAIL](state) {
      const newState = Object.assign({}, state, {
        getconversationsummary: false,
      });
      return newState;
    },
    [types.GET_CONVERSATION_DETAILS_START](state, action) {
      console.log('GET_CONVERSATION_DETAILS_START', action.convuserId);
      const newState = Object.assign({}, state, {
        getconversationDetails: true,
        latestConversationRequestId: action.convuserId,
        getconversationDetailsFail: null,
      });

      return newState;
    },
    [types.GET_CONVERSATION_DETAILS_SUCCESS](state, action) {
      const isLatest = action.convuserId === state.latestConversationRequestId;
      console.log('GET_CONVERSATION_DETAILS_SUCCESS', action.convuserId);
      const newConversations = (state.searchResults.length > 0
        ? [...state.conversations, ...state.searchResults]
        : state.conversations
      ).slice();
      for (let i = 0, l = newConversations.length; i < l; i += 1) {
        if (newConversations[i].id === action.data.id) {
          if (
            newConversations[i].details &&
            newConversations[i].details.messages &&
            newConversations[i].details.messages.length > 0
          ) {
            if (
              action.data &&
              action.data.messages &&
              action.data.messages.length > 0
            ) {
              const all_messages = Array.from(
                new Set(
                  newConversations[i].details.messages.concat(
                    action.data.messages,
                  ),
                ),
              );
              action.data.messages = all_messages;
            } else {
              action.data.messages = newConversations[i].details.messages;
            }
          }
          if (
            newConversations[i].details &&
            newConversations[i].details.events &&
            newConversations[i].details.events.length > 0
          ) {
            if (
              action.data &&
              action.data.events &&
              action.data.events.length > 0
            ) {
              const all_events = Array.from(
                new Set(
                  newConversations[i].details.events.concat(action.data.events),
                ),
              );
              action.data.events = all_events;
            } else {
              action.data.events = newConversations[i].details.events;
            }
          }
          if (
            newConversations[i].details?.voice_calls?.length > 0
          ) {
            if (!action.data) {
              action.data = {};
            }

            if (!action.data.voice_calls) {
              // If action.data.voice_calls doesn't exist, just use the existing calls
              action.data.voice_calls = [...newConversations[i].details.voice_calls];
            } else {
              // Create a map to efficiently track calls by ID
              const voiceCallsMap = new Map();

              // First add the new incoming voice calls to the map (these take priority)
              action.data.voice_calls.forEach((call) => {
                if (call.id) {
                  voiceCallsMap.set(call.id, call);
                }
              });

              // Then add existing voice calls only if they don't already exist in the map
              newConversations[i].details.voice_calls.forEach((call) => {
                if (call.id && !voiceCallsMap.has(call.id)) {
                  voiceCallsMap.set(call.id, call);
                }
              });

              // Convert map values back to array
              action.data.voice_calls = Array.from(voiceCallsMap.values());
            }
          }
          newConversations[i].details = action.data;
          if (
            action.data.bookings === undefined ||
            action.data.bookings.length < 1
          ) {
            newConversations[i].details.bookings = newConversations[i].bookings;
          }
          break;
        } else if (action.data === []) {
          if (newConversations[i].details === undefined) {
            newConversations[i].details = [];
            if (
              newConversations[i].bookings &&
              newConversations[i].bookings.length > 0
            ) {
              newConversations[i].details = {
                bookings: newConversations[i].bookings,
                doApicall: true,
              };
            }
          } else {
            if (
              newConversations[i].bookings &&
              newConversations[i].bookings.length > 0
            ) {
              newConversations[i].details = {
                bookings: newConversations[i].bookings,
                doApicall: true,
              };
            }
          }
          break;
        }
      }

      const newSearchResults = state.searchResults.slice();
      for (let i = 0, l = newSearchResults.length; i < l; i += 1) {
        if (newSearchResults[i].id === action.data.id) {
          newSearchResults[i].details = action.data;
          if (
            action.data.bookings === undefined ||
            action.data.bookings.length < 1
          ) {
            newSearchResults[i].details.bookings = newSearchResults[i].bookings;
          }
          break;
        }
      }

      return {
        ...state,
        getconversationDetails: isLatest ? false : state.getconversationDetails,
        ...(state.searchResults.length === 0 && {
          conversations: newConversations,
        }),
        ...(state.searchResults.length > 0 && {
          searchResults: newSearchResults,
        }),
      };
    },
    [types.GET_CONVERSATION_DETAILS_FAIL](state, action) {
      console.log('GET_CONVERSATION_DETAILS_FAIL', action.convuserId);
      const isLatest = action.convuserId === state.latestConversationRequestId;
      const newState = Object.assign({}, state, {
        getconversationDetails: isLatest ? false : state.getconversationDetails,
        getconversationDetailsFail: action.convuserId,
      });

      return newState;
    },
    [types.GET_CLIENT_DETAILS_START](state, action) {
      const newState = Object.assign({}, state, {
        getClientsDetails: true,
        clientsDetails: [],
      });

      return newState;
    },
    [types.GET_CLIENT_DETAILS_SUCCESS](state, action) {
      return {
        ...state,
        getClientsDetails: false,
        clientsDetails: action.data,
      };
    },
    [types.GET_CLIENT_DETAILS_FAIL](state, action) {
      const newState = Object.assign({}, state, {
        getClientsDetails: false,
      });

      return newState;
    },
    [types.GET_CLIENT_APPOINTMENTS_START](state, action) {
      const newState = Object.assign({}, state, {
        getClientsAppointments: true,
        clientsAppointments: [],
      });

      return newState;
    },
    [types.GET_CLIENT_APPOINTMENTS_SUCCESS](state, action) {
      return {
        ...state,
        getClientsAppointments: false,
        clientsAppointments: action.data,
      };
    },
    [types.GET_CLIENT_APPOINTMENTS_FAIL](state, action) {
      const newState = Object.assign({}, state, {
        getClientsAppointments: false,
      });

      return newState;
    },
    [types.CONVERSATION_READ](state, action) {
      const newConversations = state.conversations.slice();
      for (let i = 0, l = newConversations.length; i < l; i += 1) {
        if (newConversations[i].id === action.session) {
          newConversations[i].notification_read_status = 'READ';
          break;
        }
      }
      return {
        ...state,
        conversations: newConversations,
      };
    },
    [types.GET_CONVERSATION_TRANSCRIPTS_START](state) {
      return {
        ...state,
        isFetchingTranscripts: true,
      };
    },
    [types.GET_CONVERSATION_TRANSCRIPTS_SUCCESS](state, action) {
      const newConversations = state.conversations.slice();
      for (let i = 0, l = newConversations.length; i < l; i += 1) {
        if (newConversations[i].id === action.data.sessionId) {
          newConversations[i].transcripts = action.data.data;
          break;
        }
      }

      return {
        ...state,
        conversations: newConversations,
        isFetchingTranscripts: false,
      };
    },
    [types.GET_CONVERSATION_TRANSCRIPTS_FAIL](state) {
      return {
        ...state,
        isFetchingTranscripts: false,
      };
    },
    [types.POST_ERROR_REPORT_START](state) {
      const newState = Object.assign({}, state, {
        postErrorReport: true,
        errorReportSucess: false,
      });

      return newState;
    },
    [types.POST_ERROR_REPORT_SUCCESS](state, action) {
      const newState = Object.assign({}, state, {
        postErrorReport: false,
        errorReportSucess: true,
        errorReport: action.response,
      });

      return newState;
    },
    [types.POST_ERROR_REPORT_FAIL](state) {
      const newState = Object.assign({}, state, {
        postErrorReport: false,
        errorReportSucess: false,
      });

      return newState;
    },
    [types.POST_ERROR_REPORT_CLEAR](state) {
      const newState = Object.assign({}, state, {
        postErrorReport: undefined,
        errorReportSucess: undefined,
        getBlockedNUmber: undefined,
        blockedNumberSuccess: undefined,
        postunblockNumber: undefined,
        unblockSuccess: undefined,
      });

      return newState;
    },
    [types.UNBLOCK_NUMBER_START](state) {
      const newState = Object.assign({}, state, {
        postunblockNumber: true,
        unblockSuccess: false,
      });

      return newState;
    },
    [types.UNBLOCK_NUMBER_SUCCESS](state, action) {
      const newState = Object.assign({}, state, {
        postunblockNumber: false,
        unblockSuccess: true,
        errorReport: action.response,
      });

      return newState;
    },
    [types.UNBLOCK_NUMBER_FAIL](state) {
      const newState = Object.assign({}, state, {
        postunblockNumber: false,
        unblockSuccess: false,
      });

      return newState;
    },
    [types.GET_BLOCKED_NUMBERS_START](state) {
      const newState = Object.assign({}, state, {
        getBlockedNUmber: true,
      });

      return newState;
    },
    [types.GET_BLOCKED_NUMBERS_SUCCESS](state, action) {
      const newState = Object.assign({}, state, {
        getBlockedNUmber: false,
        blockedNumbers: action.response,
        blockedNumberSuccess: true,
      });

      return newState;
    },
    [types.POST_ERROR_REPORT_FAIL](state) {
      const newState = Object.assign({}, state, {
        getBlockedNUmber: false,
        blockedNumberSuccess: false,
      });

      return newState;
    },
    [types.GET_OPT_OUT_NUMBERS_START](state) {
      const newState = Object.assign({}, state, {
        getOptoutnumbers: true,
      });

      return newState;
    },
    [types.GET_OPT_OUT_NUMBERS_SUCCESS](state, action) {
      const newState = Object.assign({}, state, {
        getOptoutnumbers: false,
        optoutnumbers: action.response,
        optoutNumberSuccess: true,
      });

      return newState;
    },
    [types.GET_OPT_OUT_NUMBERS_FAIL](state, action) {
      const newState = Object.assign({}, state, {
        getOptoutnumbers: false,
        optoutNumberSuccess: false,
      });

      return newState;
    },
    [types.CREATE_CONVERSATION](state, action) {
      const newConversations = state.conversations.slice();
      newConversations.push(action.skeliton);
      let allAssignmentMap = [...state.allAssignmentMap];
      allAssignmentMap.push({
        assigned_to: action.skeliton.createdBy,
        assigned_by: action.skeliton.createdBy,
        assigned_user: action.skeliton.userId,
        session_id: action.skeliton.id,
        assignment_time: new Date(),
        location: {
          id: action.selectedLocation.studioId,
          name: action.selectedLocation.business_name,
        },
      });
      const newState = Object.assign({}, state, {
        conversations: newConversations,
        allAssignmentMap,
      });

      return newState;
    },
    [types.REMOVE_CONVERSATION](state, action) {
      const newConversations = state.conversations.slice();
      const removedConversations = newConversations.filter(
        (conversations) => conversations.id !== action.id,
      );
      const newState = Object.assign({}, state, {
        conversations: removedConversations,
      });

      return newState;
    },
    [types.CREATE_CONVERSATION_START](state) {
      const newState = Object.assign({}, state, {
        creatingNewConversation: true,
      });
      return newState;
    },
    [types.CREATE_CONVERSATION_FAIL](state) {
      const newState = Object.assign({}, state, {
        creatingNewConversation: false,
      });
      return newState;
    },
    [types.CREATE_CONTACT_SUCCESS](state, action) {
      const newConversations = state.conversations.slice();
      const allAssignmentMap = [...state.allAssignmentMap];
      const existingConversation = newConversations.filter(
        (conversation) => conversation.userId === action.data?.user_id,
      );
      let actionable = 'FOLLOWUP_NEEDED';
      console.log('newConversations 1', action, allAssignmentMap);
      for (let i = 0, l = newConversations.length; i < l; i += 1) {
        if (newConversations[i].id === action.session_id) {
          if (existingConversation && existingConversation.length > 0) {
            newConversations[i] = existingConversation[0];
            newConversations[i].jumptoThis = true;
            newConversations[i].action_updated_time = new Date().getTime();
            newConversations[i].startTime = new Date().getTime();
            newConversations[i].endTime = new Date().getTime();
            actionable = 'NONE';
          } else {
            newConversations[i].userId = action.data?.user_id;
            newConversations[i].userPhone = action.data?.user?.phone;
            newConversations[i].userName = `${action.data?.user?.first_name || ''} ${action.data?.user?.last_name || ''}`.trim();
            newConversations[i].newContactAdded = true;
            if (!newConversations[i].userName) {
              newConversations[i].userName = '';
            }
          }
          break;
        }
      }
      const updatedAssignment = allAssignmentMap.map((assignment) => {
        if (
          assignment.session_id === action.session_id &&
          actionable !== 'NONE'
        ) {
          return { ...assignment, assigned_user: action.data.user_id };
        } else {
          return assignment;
        }
      });
      console.log('newConversations 2', newConversations);
      return {
        ...state,
        conversations: newConversations,
        allAssignmentMap: updatedAssignment,
      };
    },
    [types.CLEAR_CONTACT_FLAG](state, action) {
      const newConversations = state.conversations.slice();
      for (let i = 0, l = newConversations.length; i < l; i += 1) {
        if (newConversations[i].id === action.session_id) {
          delete newConversations[i].newContactAdded;
        }
      }
      return {
        ...state,
        conversations: newConversations,
      };
    },
    [types.SELECT_CONTACT_FOR_SESSION](state, action) {
      const newConversations = state.conversations.slice();
      let allAssignmentMap = [...state.allAssignmentMap];
      const filtered_allAssignmentMap = allAssignmentMap.filter(
        (session) => session.session_id !== action.session_id,
      );
      console.log('newConversations 1', action, filtered_allAssignmentMap);
      for (let i = 0, l = newConversations.length; i < l; i += 1) {
        if (newConversations[i].id === action.session_id) {
          const existing = newConversations.filter(
            (conversation) => conversation.id === action.session_id,
          );
          if (existing && existing.length > 0) {
            newConversations[i] = existing[0];
            console.log('newConversations 3.1', newConversations[i]);
            newConversations[i].userId =
              action.contact.business_id + '-' + action.contact.user.phone;
            console.log('newConversations 3.2', newConversations[i]);
          } else {
            newConversations[i].id = action.session_id;
          }
          break;
        }
      }
      console.log('newConversations 2', newConversations);
      return {
        ...state,
        conversations: newConversations,
      };
    },
    [types.CREATE_CONVERSATION_SUCCESS](state, action) {
      const newConversations = state.conversations.slice();
      let allAssignmentMap = [...state.allAssignmentMap];
      const filtered_allAssignmentMap = allAssignmentMap.filter(
        (session) => session.session_id !== action.session_id,
      );
      console.log(
        'newConversations 1',
        action.data.session_id,
        filtered_allAssignmentMap,
      );
      for (let i = 0, l = newConversations.length; i < l; i += 1) {
        if (newConversations[i].id === action.session_id) {
          const existing = newConversations.filter(
            (conversation) => conversation.id === action.data.session_id,
          );
          if (existing && existing.length > 0) {
            newConversations[i] = existing[0];
            newConversations[i].newlyCreated = true;
          } else {
            newConversations[i].id = action.data.session_id;
          }
          break;
        }
      }
      console.log('newConversations 2', newConversations);
      return {
        ...state,
        conversations: newConversations,
        creatingNewConversation: false,
        allAssignmentMap: filtered_allAssignmentMap,
      };
    },
    [types.MINIMIZE_SIDEBAR](state, action) {
      const newState = Object.assign({}, state, {
        minimizesidebar: action.flag,
      });
      return newState;
    },
    [types.CONVERSATION_LOCATION_CHANGE](state, action) {
      const newState = Object.assign({}, state, {
        selectedLocation: action.location,
      });
      return newState;
    },
    [types.POST_MESSAGE_START](state) {
      const newState = Object.assign({}, state, {
        postClinetNotes: true,
      });
      return newState;
    },
    [types.POST_MESSAGE_SUCCESS](state) {
      const newState = Object.assign({}, state, {
        postClinetNotes: false,
      });
      return newState;
    },
    [types.POST_MESSAGE_FAIL](state) {
      const newState = Object.assign({}, state, {
        postClinetNotes: false,
      });
      return newState;
    },
    [types.POST_CLIENT_NOTES_START](state) {
      const newState = Object.assign({}, state, {
        postClinetNotes: true,
        errorMessage: null,
        isPostNoteSuccess: false,
      });
      return newState;
    },
    [types.POST_CLIENT_NOTES_SUCCESS](state, action) {
      console.log('notes 2', action);
      const newConversations = state.conversations.slice();
      const notesConversation = newConversations.filter(
        (conversation) => action.sessionId === conversation.id,
      );
      if (notesConversation?.length !== 0) {
        const index = newConversations.findIndex(
          (conversation) => conversation.id === notesConversation[0].id,
        );
        if (notesConversation[0]?.details?.notes) {
          notesConversation[0].details.notes = {
            conversation_notes: action.data.conversation_notes,
          };
        }
        notesConversation[0].notes = action.data;
        newConversations[index] = notesConversation[0];
        console.log('notes 2', newConversations);
      }
      const newState = Object.assign({}, state, {
        postClinetNotes: false,
        errorMessage: null,
        isPostNoteSuccess: true,
        conversations: newConversations,
        statusupdate: new Date(),
      });
      return newState;
    },
    [types.POST_CLIENT_NOTES_FAIL](state, action) {
      const newState = Object.assign({}, state, {
        postClinetNotes: false,
        errorMessage: action.errorMessage,
        isPostNoteSuccess: false,
      });
      return newState;
    },
    [types.CLEAR_NEWLY_CREATED_SELECTION](state) {
      const newConversations = state.conversations.slice();
      const existingConversation = newConversations.filter(
        (conversation) => conversation.newlyCreated,
      );
      const existingJumpConversation = newConversations.filter(
        (conversation) => conversation.jumptoThis,
      );
      const jumpindex =
        existingJumpConversation && existingJumpConversation.length > 0
          ? newConversations.findIndex(
            (conversation) => conversation.id === existingJumpConversation[0].id,
          )
          : -1;
      const index =
        existingConversation && existingConversation.length > 0
          ? newConversations.findIndex(
            (conversation) => conversation.id === existingConversation[0].id,
          )
          : -1;
      if (index !== -1 || jumpindex !== -1) {
        if (index !== -1) {
          delete newConversations[index].newlyCreated;
        }
        if (jumpindex !== -1) {
          delete newConversations[jumpindex].jumptoThis;
        }
        const newState = Object.assign({}, state, {
          conversations: newConversations,
          assignmentData: null,
        });
        return newState;
      } else {
        const newState = Object.assign({}, state, {
          assignmentData: null,
        });
        return newState;
      }
    },
    [types.CLEAR_JUMP_SELECTION](state) {
      const newConversations = state.conversations.slice();
      const existingConversation = newConversations.filter(
        (conversation) => conversation.jumptoThis,
      );
      const index =
        existingConversation && existingConversation.length > 0
          ? newConversations.findIndex(
            (conversation) => conversation.id === existingConversation[0].id,
          )
          : -1;
      if (index !== -1) {
        delete newConversations[index].jumptoThis;
        const newState = Object.assign({}, state, {
          conversations: newConversations,
          assignmentData: null,
        });
        return newState;
      } else {
        const newState = Object.assign({}, state, {
          assignmentData: null,
        });
        return newState;
      }
    },
    [types.POST_ASSIGN_CONVERSATIONS_SUCCESS](state, action) {
      const { data, requestParam } = action;

      // Update allAssignmentMap based on API response
      let allAssignmentMap = [...state.allAssignmentMap];

      // Remove any existing assignment for this user_id (in case of reassignment)
      allAssignmentMap = allAssignmentMap.filter(
        (assignment) => assignment.assigned_user !== data.user_id,
      );

      // Add the new assignment
      if (requestParam.assigned_to) {
        allAssignmentMap.push({
          assigned_to: requestParam.assigned_to,
          assigned_user: data.user_id,
          assigned_by: data.updated_by,
          session_id: data.session_id,
          assignment_time: new Date(data.updated_time),
          // Note: location might need to be derived from context or added to API response
          location: state.selectedLocation || { id: '', name: '' },
        });
      }

      // Update the conversation status if needed
      const newConversations = state.conversations.slice();
      const conversationIndex = newConversations.findIndex(
        (conversation) => conversation.id === data.session_id,
      );

      if (conversationIndex !== -1) {
        // Update conversation with assignment info
        newConversations[conversationIndex] = {
          ...newConversations[conversationIndex],
          auto_chat_status: data.status,
          auto_chat_status_updated_by: data.updated_by,
          auto_chat_status_updated_time: data.updated_time,
          // Add any other relevant fields from the API response
        };
      }

      const newData = {
        ...data,
        ...(requestParam.assigned_to && { assigned_to: requestParam.assigned_to }),
      };
      return {
        ...state,
        allAssignmentMap,
        conversations: newConversations,
        assignmentData: newData,
        socketUpdate: new Date(),
        statusupdate: new Date(),
        // Clear any loading states if you have them
        assigningConversation: false,
        assignmentError: null,
      };
    },

    // Also add handlers for the request lifecycle
    [types.POST_ASSIGN_CONVERSATIONS_START](state) {
      return {
        ...state,
        assigningConversation: true,
        assignmentError: null,
      };
    },

    [types.POST_ASSIGN_CONVERSATIONS_FAIL](state, action) {
      return {
        ...state,
        assigningConversation: false,
        assignmentError: action.error || 'Assignment failed',
      };
    },
    [types.GET_CONVERSATION_MESSAGE](state, action) {
      const newConversations = state.conversations.slice();
      const newconversationSummary = { ...state.conversationSummary };
      let allAssignmentMap = [...state.allAssignmentMap];
      let temp_sesssioncounter = state.sessioncounter;
      let markResolved = state.markResolved;
      let assignmentData = { ...state.assignmentData };
      let incomingMessage = null;
      let callerNameChangeSuccess = false;
      let callerNameChangeFailure = false;
      let counts = { ...state.counts };

      // HANDLE ASSIGNMENT EVENTS FIRST TO PREVENT RACE CONDITIONS
      if (action.action.type === '/assignment') {
        const user = utils.getCookie('user');
        const { data } = action.action;
        console.log('Processing assignment first:', data);

        assignmentData = data;
        markResolved = null;

        if (data.was_assigned_to) {
          allAssignmentMap = allAssignmentMap.filter(
            (assignment) => assignment.assigned_user !== data.user_id,
          );
        }

        if (data.assigned_to) {
          allAssignmentMap.push({
            assigned_to: data.assigned_to,
            assigned_user: data.user_id,
            assigned_by: data.assigned_by,
            location: data.location,
          });
        }

        console.log('Updated allAssignmentMap:', allAssignmentMap);

        // Return early for assignment events to ensure they're processed immediately
        return {
          ...state,
          conversationSummary: newconversationSummary,
          sessioncounter: temp_sesssioncounter,
          markResolved,
          allAssignmentMap, // This is the critical update
          socketUpdate: new Date(),
          assignmentData,
          incomingMessage,
          callerNameChangeSuccess,
          callerNameChangeFailure,
        };
      }

      // Handle all other event types
      if (action.action.type === '/message') {
        const { data } = action.action;
        const existingConversation = newConversations.filter(
          (conversation) => data.sessionId === conversation.id,
        );
        incomingMessage = data.sender === 'USER' ? data.sessionId : null;
        if (existingConversation.length !== 0) {
          const index = newConversations.findIndex(
            (conversation) => conversation.id === existingConversation[0].id,
          );
          if (
            existingConversation[0].details &&
            existingConversation[0].details.messages === undefined
          ) {
            existingConversation[0].details.messages = [];
            existingConversation[0].details.messages.push(data);
          } else if (
            existingConversation[0].details &&
            existingConversation[0].details.messages.length > -1
          ) {
            existingConversation[0].details.messages.push(data);
          }
          if (existingConversation[0].details === undefined) {
            existingConversation[0].details = { doApicall: true };
            existingConversation[0].details.messages = [];
            existingConversation[0].details.messages.push(data);
          }
          newConversations[index] = existingConversation[0];
        }
      } else if (action.action.type === '/voicemail') {
        const { data } = action.action;
        const existingConversation = newConversations.find(
          (conversation) => data.session_id === conversation.id,
        );

        if (existingConversation && (data?.channel === 'TWILIO_CALL' || data?.channel === 'WEAVE_CALL')) {
          existingConversation.details = existingConversation.details || {};
          existingConversation.details.voice_calls = existingConversation.details.voice_calls || [];

          const callIndex = existingConversation.details.voice_calls.findIndex(
            (call) => call.id === data.id,
          );
          data.status = existingConversation?.status || '';
          data.tags = existingConversation?.tags || [];
          if (callIndex > -1) {
            existingConversation.details.voice_calls[callIndex] = data;
          } else {
            existingConversation.details.voice_calls.push(data);
          }
        }
      } else if (action.action.type === '/session') {
        const { data } = action.action;
        console.log('Processing session after assignment handled:', data.id);
        if (
          helpers.isBrandLocation(state.selectedLocation) ||
          data.accounts.includes(state.selectedLocation.studioId) ||
          utils.isEmptyObject(state.selectedLocation)
        ) {
          temp_sesssioncounter = temp_sesssioncounter + 1;
          const existingConversation = newConversations.filter(
            (conversation) => data.id === conversation.id,
          );
          if (existingConversation?.length === 0) {
            if (data.bookings === undefined) {
              data.bookings = [];
            }
            newconversationSummary.conversation_count =
              newconversationSummary.conversation_count + 1;
            if (data.action === 'HANDLED') {
              newconversationSummary.handled_count =
                newconversationSummary.handled_count + 1;
            } else if (data.action === 'FOLLOWUP_NEEDED') {
              newconversationSummary.followup_count =
                newconversationSummary.followup_count + 1;
            }
            newConversations.push(data);
          } else {
            const index = newConversations.findIndex(
              (conversation) => conversation.id === existingConversation[0].id,
            );
            if (existingConversation[0].staffCreated) {
              existingConversation[0] = data;
              existingConversation[0].newlyCreated = true;
            }
            if (existingConversation[0].newlyCreated) {
              data.newlyCreated = true;
            }
            if (data.bookings === undefined) {
              data.bookings = [];
            }
            if (existingConversation[0] && existingConversation[0].details) {
              data.details = existingConversation[0].details;
              if (data.notes && data.notes.conversation_notes) {
                data.details.notes = data.notes;
              }
            }
            if (
              existingConversation[0] &&
              existingConversation[0].events &&
              existingConversation[0].events.length > 0
            ) {
              data.events = existingConversation[0].events;
            }
            if (
              existingConversation[0] &&
              existingConversation[0].bookings &&
              existingConversation[0].bookings.length > 0
            ) {
              data.bookings = existingConversation[0].bookings;
            }
            if (
              existingConversation[0].notification_status &&
              !data.notification_status
            ) {
              data.notification_status =
                existingConversation[0].notification_status;
            }
            if (
              existingConversation[0].action === 'NONE' &&
              data.action === 'HANDLED'
            ) {
              newconversationSummary.handled_count =
                newconversationSummary.handled_count + 1;
              markResolved = existingConversation[0].id;
            }
            if (
              existingConversation[0].action === 'NONE' &&
              data.action === 'FOLLOWUP_NEEDED'
            ) {
              newconversationSummary.followup_count =
                newconversationSummary.followup_count + 1;
            } else if (
              existingConversation[0].action === 'FOLLOWUP_NEEDED' &&
              data.action === 'HANDLED'
            ) {
              newconversationSummary.followup_count =
                newconversationSummary.followup_count - 1;
              newconversationSummary.handled_count =
                newconversationSummary.handled_count + 1;
              markResolved = existingConversation[0].id;
            } else if (
              existingConversation[0].action === 'HANDLED' &&
              data.action === 'FOLLOWUP_NEEDED'
            ) {
              newconversationSummary.followup_count =
                newconversationSummary.followup_count + 1;
              newconversationSummary.handled_count =
                newconversationSummary.handled_count - 1;
            }
            newConversations[index] = data;
          }
        } else {
          console.log('NoN Selected', data);
        }
      } else if (action.action.type === '/booking') {
        const { data } = action.action;
        let extConv = [];
        for (let i = 0; i < newConversations.length; i++) {
          if (newConversations[i].id === data.session_id) {
            extConv.push(newConversations[i]);
          }
        }
        if (extConv.length !== 0) {
          const index = newConversations.findIndex(
            (conversation) => conversation.id === extConv[0].id,
          );
          const existingooking = extConv[0].bookings.filter(
            (booking) => booking.id === data.id,
          );
          if (existingooking.length > 0) {
            const bookingindex = extConv[0].bookings.findIndex(
              (booking) => booking.id === data.id,
            );
            extConv[0].bookings[bookingindex] = data;
          } else {
            extConv[0].bookings.push(data);
          }
          if (extConv[0].details) {
            extConv[0].details.bookings = extConv[0].bookings;
          }
          newConversations[index] = extConv[0];
        }
      } else if (action.action.type === '/notification') {
        const { data } = action.action;
        const existingConversation = newConversations.filter(
          (conversation) => data.sessionId === conversation.id,
        );
        if (existingConversation.length !== 0) {
          const index = newConversations.findIndex(
            (conversation) => conversation.id === existingConversation[0].id,
          );
          if (
            existingConversation[0].details &&
            existingConversation[0].details.notifications === undefined
          ) {
            existingConversation[0].notifications = [];
            existingConversation[0].details.notifications = [];
            existingConversation[0].notifications.push(data);
            existingConversation[0].details.notifications.push(data);
            if (data.category === 'ACTIONABLE') {
              existingConversation[0].notification_status = 'FOLLOWUP_NEEDED';
            }
          } else if (
            existingConversation[0].details &&
            existingConversation[0].details.notifications.length > -1
          ) {
            existingConversation[0].details.notifications.push(data);
            if (data.category === 'ACTIONABLE') {
              existingConversation[0].notification_status = 'FOLLOWUP_NEEDED';
            }
          }
          newConversations[index] = existingConversation[0];
        }
      } else if (action.action.type === '/business-event') {
        const { data } = action.action;
        const existingConversation = newConversations.filter(
          (conversation) => data.sessionId === conversation.id,
        );
        if (existingConversation.length !== 0) {
          const index = newConversations.findIndex(
            (conversation) => conversation.id === existingConversation[0].id,
          );
          if (data.subType === 'CALLER_NAME_UPDATE_SUCCESS' || data.subType === 'CALLER_NAME_UPDATE_FAILURE') {
            callerNameChangeSuccess = data.subType === 'CALLER_NAME_UPDATE_SUCCESS';
            callerNameChangeFailure = !callerNameChangeSuccess;
          } else {
            if (
              existingConversation[0].details &&
              existingConversation[0].details.events === undefined
            ) {
              existingConversation[0].events = [];
              existingConversation[0].details.events = [];
              existingConversation[0].events.push(data);
              existingConversation[0].details.events.push(data);
            } else if (
              existingConversation[0].details &&
              existingConversation[0].details.events.length > -1
            ) {
              existingConversation[0].details.events.push(data);
            }
            newConversations[index] = existingConversation[0];
          }
        }
      } else if (action.action.type === '/user') {
        const { data } = action.action;
        const existingConversation = newConversations.filter(
          (conversation) => data.id === conversation.userId,
        );
        console.log('User Data', data, existingConversation);
        if (existingConversation.length !== 0) {
          for (let i = 0; i < existingConversation.length; i++) {
            const index = newConversations.findIndex(
              (conversation) => conversation.id === existingConversation[i].id,
            );
            if (
              existingConversation[i].details &&
              existingConversation[i].details.user_tags === undefined
            ) {
              existingConversation[i].details.user_tags = [];
              existingConversation[i].details.user_tags = data.conversation_tags;
            } else if (
              existingConversation[i].details &&
              existingConversation[i].details.user_tags.length > -1
            ) {
              existingConversation[i].details.user_tags = data.conversation_tags;
            }
            if (existingConversation[i].details === undefined) {
              existingConversation[i].details = { doApicall: true };
              existingConversation[i].details.user_tags = [];
              existingConversation[i].details.user_tags = data.conversation_tags;
            }
            existingConversation[i].conversation_tags = data.conversation_tags;
            newConversations[index] = existingConversation[i];
          }
        }
      } else if (action.action.type === '/conversation_stats') {
        const { data } = action.action; // this is the delta
        const currentSets = {
          total_user_ids: new Set(counts.total_user_ids),
          unassigned_user_ids: new Set(counts.unassigned_user_ids),
          all_assigned_user_ids: new Set(counts.all_assigned_user_ids),
          mine_user_ids: new Set(counts.mine_user_ids),
        };
        // 1. Add delta.total_user_ids to total_user_ids (Union)
        if (data.total_user_ids) {
          data.total_user_ids.forEach((id) => currentSets.total_user_ids.add(id));
        }

        // 2. Add delta.unassigned_user_ids to unassigned_user_ids (Union)
        if (data.unassigned_user_ids) {
          data.unassigned_user_ids.forEach((id) => currentSets.unassigned_user_ids.add(id));
        }

        // 3. Replace all_assigned_user_ids (Reset and Fill)
        currentSets.all_assigned_user_ids = new Set(data.all_assigned_user_ids || []);

        // 4. Replace mine_user_ids (Reset and Fill)
        currentSets.mine_user_ids = new Set(data.mine_user_ids || []);

        // 5. Update unassigned_user_ids by removing all_assigned_user_ids (Set Difference)
        currentSets.all_assigned_user_ids.forEach((id) => {
          currentSets.unassigned_user_ids.delete(id);
        });

        counts = {
          total_user_ids: Array.from(currentSets.total_user_ids),
          unassigned_user_ids: Array.from(currentSets.unassigned_user_ids),
          all_assigned_user_ids: Array.from(currentSets.all_assigned_user_ids),
          mine_user_ids: Array.from(currentSets.mine_user_ids),
          mycount: currentSets.mine_user_ids.size,
          allcount: currentSets.total_user_ids.size,
          needsattentioncount: currentSets.unassigned_user_ids.size,
        };
      }

      // Return final state for all non-assignment events
      // Note: allAssignmentMap is NOT modified here, preserving any assignment changes
      const newState = Object.assign({}, state, {
        conversations: newConversations,
        conversationSummary: newconversationSummary,
        sessioncounter: temp_sesssioncounter,
        markResolved,
        allAssignmentMap, // This preserves the original state for non-assignment events
        socketUpdate: new Date(),
        assignmentData,
        incomingMessage,
        callerNameChangeSuccess,
        callerNameChangeFailure,
        counts,
      });
      return newState;
    },
    [types.CLEAR_NOTIFICATION_MESSAGE](state) {
      const newState = Object.assign({}, state, {
        incomingMessage: null,
      });
      return newState;
    },
    [types.ATTENTION_COUNT](state, action) {
      const newState = Object.assign({}, state, {
        sidenav_count: action.count,
      });
      return newState;
    },
    [types.GET_ASSIGNED_CONVERSATIONS_START](state) {
      const newState = Object.assign({}, state, {
        getAssignedConversation: true,
      });
      return newState;
    },
    [types.GET_ASSIGNED_CONVERSATIONS_FAIL](state) {
      const newState = Object.assign({}, state, {
        getAssignedConversation: false,
      });
      return newState;
    },
    [types.GET_ASSIGNED_CONVERSATIONS_SUCCESS](state, action) {
      const newState = Object.assign({}, state, {
        assignedConversation: action.data.client_assignments,
        allAssignedConversation: action.data.users_assigned,
        allAssignmentMap: action.data.user_assignments,
        getAssignedConversation: false,
      });
      return newState;
    },
    [types.POST_AUTO_RESPONSE_START](state) {
      const newState = Object.assign({}, state, {
        autoResponseChange: true,
      });
      return newState;
    },
    [types.POST_AUTO_RESPONSE_FAIL](state) {
      const newState = Object.assign({}, state, {
        autoResponseChange: false,
      });
      return newState;
    },
    [types.POST_AUTO_RESPONSE_SUCCESS](state, action) {
      const newConversations = state.conversations.slice();
      const existingConversation = newConversations.filter(
        (conversation) => action.sessionId === conversation.id,
      );
      const index = newConversations.findIndex(
        (conversation) => conversation.id === existingConversation[0].id,
      );
      existingConversation[0].auto_chat_status = action.response.status;
      newConversations[index] = existingConversation[0];
      const newState = Object.assign({}, state, {
        autoResponseChange: false,
        conversations: newConversations,
      });
      return newState;
    },
    [types.SEARCH_CONTACT_START](state, action) {
      const newState = Object.assign({}, state, {
        ...(!action.isAdvancedSearch && { ongoingSearch: true }),
        ...(action.isAdvancedSearch && { isAdvancedSearch: true }),
      });
      return newState;
    },
    [types.SEARCH_CONTACT_SUCCESS](state, action) {
      const newState = Object.assign({}, state, {
        ...(!action.isAdvancedSearch && { contactSearch: action.response }),
        ...(action.isAdvancedSearch && { advancedSearch: action.response }),
        ongoingSearch: false,
        isAdvancedSearch: false,
      });
      return newState;
    },
    [types.SEARCH_CONTACT_FAIL](state) {
      const newState = Object.assign({}, state, {
        ongoingSearch: false,
        isAdvancedSearch: false,
      });
      return newState;
    },
    [types.GET_CONVERSATION_METRICS_START](state) {
      const newState = Object.assign({}, state, {
        getConversationMetrics: true,
        fetchConversationMetricsSuccess: false,
      });
      return newState;
    },
    [types.GET_CONVERSATION_METRICS_SUCCESS](state, action) {
      console.log('conversationMetrics', action);
      const newState = Object.assign({}, state, {
        getConversationMetrics: false,
        conversationMetrics: action.data,
        fetchConversationMetricsSuccess: true,
      });
      return newState;
    },
    [types.GET_CONVERSATION_METRICS_FAIL](state) {
      const newState = Object.assign({}, state, {
        getConversationMetrics: false,
        fetchConversationMetricsSuccess: false,
      });
      return newState;
    },
    [types.POST_CONVERSATION_SEARCH_START](state) {
      const newState = Object.assign({}, state, {
        searchingConversation: true,
        loadingMore: true,
      });
      return newState;
    },
    [types.POST_CONVERSATION_SEARCH_SUCCESSS](state, action) {
      const newState = Object.assign({}, state, {
        searchingConversation: false,
        loadingMore: false,
        searchResults: action.searchResults,
      });
      return newState;
    },
    [types.POST_CONVERSATION_SEARCH_FAIL](state) {
      const newState = Object.assign({}, state, {
        searchingConversation: false,
        loadingMore: false,
      });
      return newState;
    },
    [types.GET_CUSTOM_TAGS_START](state, action) {
      const newState = Object.assign({}, state, {
        getCustomTag: true,
      });
      return newState;
    },
    [types.GET_CUSTOM_TAGS_SUCCESS](state, action) {
      const newState = Object.assign({}, state, {
        getCustomTag: false,
        custom_tags: action.data,
      });
      return newState;
    },
    [types.GET_CUSTOM_TAGS_FAIL](state, action) {
      const newState = Object.assign({}, state, {
        getCustomTag: false,
      });
      return newState;
    },

    [types.ADD_CUSTOM_TAGS_START](state, action) {
      const newState = Object.assign({}, state, {
        getCustomTag: true,
        addTags: true,
      });
      return newState;
    },
    [types.ADD_CUSTOM_TAGS_SUCCESS](state, action) {
      const newState = Object.assign({}, state, {
        getCustomTag: false,
        custom_tags: action.data,
        addTags: false,
      });
      return newState;
    },
    [types.ADD_CUSTOM_TAGS_FAIL](state, action) {
      const newState = Object.assign({}, state, {
        getCustomTag: false,
        addTags: false,
      });
      return newState;
    },
    [types.DELETE_CUSTOM_TAG_START](state, action) {
      const newState = Object.assign({}, state, {
        getCustomTag: true,
        deleteTags: true,
      });
      return newState;
    },
    [types.DELETE_CUSTOM_TAG_SUCCESS](state, action) {
      const newState = Object.assign({}, state, {
        getCustomTag: false,
        custom_tags: action.data,
        deleteTags: false,
      });
      return newState;
    },
    [types.DELETE_CUSTOM_TAG_FAIL](state, action) {
      const newState = Object.assign({}, state, {
        getCustomTag: false,
        deleteTags: false,
      });
      return newState;
    },
    [types.ADD_TAG_TO_USER_START](state, action) {
      const newState = Object.assign({}, state, {
        addingTagToUser: true,
      });
      return newState;
    },
    [types.ADD_TAG_TO_USER_SUCCESS](state, action) {
      const newConversations = state.conversations.slice();
      const existingConversation = newConversations.filter(
        (conversation) => action?.conversation?.id === conversation.id,
      );
      if (existingConversation.length !== 0) {
        for (let i = 0; i < existingConversation.length; i++) {
          const index = newConversations.findIndex(
            (conversation) => conversation.id === existingConversation[i].id,
          );

          if (
            existingConversation[i].details &&
            existingConversation[i].details.user_tags === undefined
          ) {
            existingConversation[i].details.user_tags = [];
            existingConversation[i].details.user_tags = action.data;
          } else if (
            existingConversation[i].details &&
            existingConversation[i].details.user_tags.length > -1
          ) {
            existingConversation[i].details.user_tags = action.data;
          }
          if (existingConversation[i].details === undefined) {
            existingConversation[i].details = { doApicall: true };
            existingConversation[i].details.user_tags = [];
            existingConversation[i].details.user_tags = action.data;
          }
          existingConversation[i].conversation_tags = action.data;
          newConversations[index] = existingConversation[i];
        }
      }
      const newState = Object.assign({}, state, {
        addingTagToUser: false,
        conversations: newConversations,
      });
      return newState;
    },
    [types.ADD_TAG_TO_USER_FAIL](state, action) {
      const newState = Object.assign({}, state, {
        addingTagToUser: false,
      });
      return newState;
    },

    [types.REMOVE_TAGOF_USER_START](state, action) {
      const newState = Object.assign({}, state, {
        removingTagToUser: true,
      });
      return newState;
    },
    [types.REMOVE_TAGOF_USER_SUCCESS](state, action) {
      const newConversations = state.conversations.slice();
      const existingConversation = newConversations.filter(
        (conversation) => action?.conversation?.id === conversation.id,
      );
      if (existingConversation.length !== 0) {
        for (let i = 0; i < existingConversation.length; i++) {
          const index = newConversations.findIndex(
            (conversation) => conversation.id === existingConversation[i].id,
          );
          if (
            existingConversation[i].details &&
            existingConversation[i].details.user_tags === undefined
          ) {
            existingConversation[i].details.user_tags = [];
            existingConversation[i].details.user_tags = action.data;
          } else if (
            existingConversation[i].details &&
            existingConversation[i].details.user_tags.length > -1
          ) {
            existingConversation[i].details.user_tags = action.data;
          }
          if (existingConversation[i].details === undefined) {
            existingConversation[i].details = { doApicall: true };
            existingConversation[i].details.user_tags = [];
            existingConversation[i].details.user_tags = action.data;
          }
          existingConversation[i].conversation_tags = action.data;
          newConversations[index] = existingConversation[i];
        }
      }
      const newState = Object.assign({}, state, {
        removingTagToUser: false,
        conversations: newConversations,
      });
      return newState;
    },
    [types.REMOVE_TAGOF_USER_FAIL](state, action) {
      const newState = Object.assign({}, state, {
        removingTagToUser: false,
      });
      return newState;
    },

  },
);

export { conversations as default };
